import { LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE, ORDER_BY } from '@app/constants/Common';
import { calculateYearsBetweenDates } from '@app/utils/DateTimeUtils';
import DVTJCUVEmailInviteModal, { EmailInviteMode } from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import {
    DVTJCUVAcquireCddEmailFUTabs,
    DVTJCUVAcquireCddParentTabIds,
    DVTJCUVAcquireCddPreEmailTabs,
    DVTJCUVAcquireCddSendEmailTabs, DVTJCUVAcquireCddUVNeedCallChatTabs
} from '@pages/dvtjcuv/common/AcquireCddTabs';
import { TodoWCddSortOrder } from "@pages/dvtjcuv/common/Constant";
import UpdateDVTJCUVPipelineModal from '@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal';
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from '@pages/dvtjcuv/list/DVTJCUVPipelineTableList';
import DVTJCUVPipelineNextStragyCompaignGroupList from "@pages/dvtjcuv/rundvtjcuv/DVTJCUVPipelineNextStragyCompaignGroupList";
import HeaderSearchButtons from '@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons';
import RunDVTJCUVCandidateList from "@pages/dvtjcuv/rundvtjcuv/RunDVTJCUVCandidateList";
import SelectDVTJCUVMailTemplateModal from "@pages/dvtjcuv/rundvtjcuv/SelectDVTJCUVMailTemplateModal";
import { requestGetDVTJCUVPipeLineList } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import React, { useEffect, useState } from 'react';
import Button from "react-bootstrap/Button";

const PipeLineSortOption = {
    NOTE_TIME_ASC: '1',
    NOTE_TIME_DESC: '2',
    FU_SCHEDULE_NEXT_TIME_ASC: '3',
    FU_SCHEDULE_NEXT_TIME_DESC: '4',
}

const AcquireCddsContent = (props) => {
    const [parentOfTab, setParentOfTab] = useState({});
    const [currentTab, setCurrentTab] = useState({});
    const [pipelineList, setPipelineList] = useState([]);
    const [childTabList, setChildTabList] = useState([]);
    const [dataInfo, setDataInfo] = useState({});
    const [mailTabData, setMailTabData] = useState({});
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showSelectMailTemplateModal, setShowSelectTemplateModal] = useState(false);
    const [sortBy, setSortBy] = useState(PipeLineSortOption.NOTE_TIME_ASC);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [sortPipeColumns, setSortPipeColumns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });
    const [selectPipelines, setSelectPipelines] = useState([]);
    const [showBtnSearchPipeline, setShowBtnSearchPipeline] = useState(false);
    const [showDVTJCUVEmailInviteModal, setShowDVTJCUVEmailInviteModal] = useState(false);
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);

    const {data, parentTab} = props

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])


    const getTodoWCddSortOrder = (item) => {
        if (item.to_do_w_cdd) {
            return TodoWCddSortOrder.findIndex((value) => {
                return value.toLowerCase() === item.to_do_w_cdd.toLowerCase();
            });
        }
        return TodoWCddSortOrder.length
    }

    const sortByConditions = (inputPipelines, sortOption) => {
        //TODO: không tìm thấy chỗ map yc nội dung này nữa
        // if (parentTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB) {
        //     return inputPipelines.sort((a, b) => {
        //         // Sắp xếp theo `to_do_w_sort_order` tăng dần
        //         if (a.to_do_w_cdd_sort_order !== b.to_do_w_cdd_sort_order) {
        //             return a.to_do_w_cdd_sort_order - b.to_do_w_cdd_sort_order;
        //         }
        //         // Nếu `to_do_w_cdd_sort_order` bằng nhau, sắp xếp theo `created_date_time (note_time)` giảm dần hoặc tăng dần tuỳ theo điều kiện SortBy
        //         if (sortOption === PipeLineSortOption.NOTE_TIME_DESC) {
        //             return b.id - a.id;
        //         }
        //         return a.id - b.id;
        //     });
        // }


        // return inputPipelines.sort((a, b) => {
        //     if (sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_ASC || sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_DESC) {
        //         const aDate = convertVNDateTimeToDate(a.next_fu_schedule_date_time);
        //         const bDate = convertVNDateTimeToDate(b.next_fu_schedule_date_time);
        //         // Nếu `dateA` là null hoặc trống, đưa nó xuống cuối
        //         if (aDate === null && bDate !== null) return 1;
        //         if (aDate !== null && bDate === null) return -1;

        //         // Nếu cả hai đều là null hoặc trống, coi chúng là bằng nhau
        //         if (aDate === null && bDate === null) return 0;
        //         if (sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_ASC) {
        //             return aDate - bDate;
        //         }

        //         if (sortOption === PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_DESC) {
        //             return bDate - aDate;
        //         }
        //     }


        //     if (sortOption === PipeLineSortOption.NOTE_TIME_DESC) {
        //         return b.id - a.id;
        //     }
        //     return a.id - b.id;
        // });
        return inputPipelines
    }

    const setDisplayPipelineList = (pipes, sortOption) => {
        const duringNextOneYearItems = []
        const overNextOneYearItems = []
        const otherItems = []
        const currentTime = new Date()
        pipes.forEach((item, index) => {
            item.no = index + 1
            item.hightlight_class = ''
            item.to_do_w_cdd_sort_order = getTodoWCddSortOrder(item);
            if (item.has_find_job_mode_on && item.current_find_job_mode_note_time) {
                const noteDateTime = new Date(item.current_find_job_mode_note_time)
                if (calculateYearsBetweenDates(noteDateTime, currentTime) <= 1) {
                    item.hightlight_class = 'text-danger text-bold'
                    duringNextOneYearItems.push(item);
                } else {
                    item.hightlight_class = 'text-primary'
                    overNextOneYearItems.push(item);
                }
            } else {
                otherItems.push(item)
            }
        });
        setPipelineList(
            [
                ...sortByConditions(duringNextOneYearItems, sortOption),
                ...sortByConditions(overNextOneYearItems, sortOption),
                ...sortByConditions(otherItems, sortOption)
            ]
        );
    }

    const fetchPipeLines = async (pTab, sTab) => {
        const params = {
            search_conditions: {
                parent_tab: pTab.id,
                sub_tab: sTab ? sTab.id : "",
                unlimited: true,
            },
            sort_columns: sortPipeColumns
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        const resContent = res.content

        setDisplayPipelineList(resContent.pipelines, sortBy)
    }

    const onTabClicked = async (ctab) => {
        setCurrentTab({...ctab});
        // if (ctab.id === DVTJCUVAcquireCddPreEmailTabIds.UV_HAS_NEW_EMAIL) {
        //     await fetchPipeLines(parentOfTab, ctab)
        // }

        if (
            parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.HOT_JOB_NOT_HAS_PLAN_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_REP_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.PENDING_PROCESS_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.SERVICE_EXPIRE_TAB
        ) {
            fetchPipeLines(parentOfTab, ctab)
        }
    };

    const activeTab = (ctab) => {
        if (currentTab.id === ctab.id) {
            return 'active'
        }
        return ''
    }

    const setTabContents = (pTab) => {
        let currTab = {...DVTJCUVAcquireCddSendEmailTabs[0]}
        let childTabs = [...DVTJCUVAcquireCddSendEmailTabs]
        if (pTab.id === DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB) {
            currTab = {...DVTJCUVAcquireCddPreEmailTabs[0]}
            childTabs = [...DVTJCUVAcquireCddPreEmailTabs]
        } else if (pTab.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB) {
            currTab = {...DVTJCUVAcquireCddSendEmailTabs[0]}
            childTabs = [...DVTJCUVAcquireCddSendEmailTabs]
        } else if (pTab.id === DVTJCUVAcquireCddParentTabIds.FU_EMAIL_TAB) {
            currTab = {...DVTJCUVAcquireCddEmailFUTabs[0]}
            childTabs = [...DVTJCUVAcquireCddEmailFUTabs]
        } else if (pTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB) {
            currTab = {...DVTJCUVAcquireCddUVNeedCallChatTabs[0]}
            childTabs = [...DVTJCUVAcquireCddUVNeedCallChatTabs]
            fetchPipeLines(pTab, currTab)
        } else if (
            // pTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB
            pTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB
            || pTab.id === DVTJCUVAcquireCddParentTabIds.HOT_JOB_NOT_HAS_PLAN_TAB
            || pTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_REP_TAB
            || pTab.id === DVTJCUVAcquireCddParentTabIds.PENDING_PROCESS_TAB
            || pTab.id === DVTJCUVAcquireCddParentTabIds.SERVICE_EXPIRE_TAB
        ) {
            fetchPipeLines(pTab)
        } else {
            currTab = {}
            childTabs = []
        }

        setParentOfTab(pTab)
        setCurrentTab(currTab)
        setChildTabList(childTabs)
        setShowBtnSearchPipeline(pTab.id !== DVTJCUVAcquireCddParentTabIds.EMAIL_TAB
            && pTab.id !== DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB)
    }

    useEffect(() => {
        if (parentTab) {
            setTabContents(parentTab)
        }
        if (data) {
            setDataInfo(data)
        }
    }, [data, parentTab]);

    const onSelectTemplate = () => {
        setShowSelectTemplateModal(true);
    }

    const onConfirmSelectTemplate = (templateId) => {
        // todo: update sau, cần làm rõ dataInfo có phải luwu thông tin run DVTJCUV hay không.
        dataInfo.mail_template_id = templateId
        setShowSelectTemplateModal(false);
    }

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({...item})
        setShowUpdatePipelineModal(true)
    }

    const onChangeSortOption = (event) => {
        setSortBy(event.target.value)
        setDisplayPipelineList([...pipelineList], event.target.value)
    }

    const isShowCandidateList = () => {
        return (
            (
                parentOfTab.id === DVTJCUVAcquireCddParentTabIds.PRE_EMAIL_TAB
            )
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.FU_EMAIL_TAB
            || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB
        )
    }

    const onSelectItems = (items) => {
        console.log("Select items", items)
        setSelectPipelines(items)
    }

    const onSortPipelines = async (columnKey) => {
        // alert('on sort pipelines:' + JSON.stringify(columnKey))
        let sortColumns = {...sortPipeColumns}
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        setSortPipeColumns(sortColumns)
        await fetchPipeLines(parentOfTab, currentTab)
    }

    const setShowCandidateListTabContent = (ctab) => {
        if (parentTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB) {
            return <div id={ctab.id} className={`tab-pane ${activeTab(ctab)}`}
                        style={{height: '83vh', overflow: 'auto'}}
                        key={`run-job-sub-tab-content-${parentTab.id}-${ctab.id}`}>
                <div className='card card-default'>
                    <div className='card-header'>
                        <h3 className='card-title text-bold'>Danh sách DVTJCUV Pipelines</h3>
                        <div className={'card-tools'}>
                            {/* <button type='button'
                                    className='btn btn-default float-right'
                                    disabled={selectPipelines.length === 0}
                                    onClick={() => {
                                        setShowDVTJCUVEmailInviteModal(true)
                                    }}
                            >
                                Gửi email mời
                            </button> */}
                        </div>
                    </div>
                    <div className='card-body p-0'>
                        <DVTJCUVPipelineTableList
                            pipeLines={pipelineList}
                            onSort={onSortPipelines}
                            sortColumn={sortPipeColumns}
                            mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD}
                            showBtnSelect
                            hideColumns={[]}
                            parentTabId={parentTab.id}
                            subTabId={currentTab.id}
                            onSelectItems={(items => {
                                onSelectItems(items)
                            })}
                            onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                        />
                    </div>
                </div>

            </div>
        }

        return <div id={ctab.id} className={`tab-pane ${activeTab(ctab)}`}
             style={{height: '83vh', overflow: 'auto'}}
             key={`run-job-sub-tab-content-${parentTab.id}-${ctab.id}`}>
            <RunDVTJCUVCandidateList runJob={dataInfo}
                                     parentTab={parentOfTab}
                                     subTab={currentTab}
            />
        </div>

    }

    const setShowPipelineListTabContent = () => {
        if (parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB) {
            return <DVTJCUVPipelineNextStragyCompaignGroupList
                pipelineIds={pipelineList.map(item => {return item.id})}
                parentTab={parentOfTab}
            />
        }

        return <DVTJCUVPipelineTableList
            pipeLines={pipelineList}
            mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_ACQUIRE_CDD}
            hideColumns={[]}
            parentTabId={parentOfTab.id}
            showBtnSelect
            onSelectItems={(items => {
                onSelectItems(items)
            })}
            // showBtnAddPipelineOnRefereeInput={showBtnAddPipelineOnRefereeInput}
            onSort={onSortPipelines}
            sortColumn={sortPipeColumns}
            onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
            // onClose={(reload) => onCloseUpdatePipeLine(reload)}
        />
    }

    const onEmailFU = async (pipelines) => {
        // await fetchCandidateList(runJobInfo, parentTab, subTab, currentPage, true)
        setSelectPipeline(pipelines)
        setShowFollowUpModal(true)
    }

    return (
        <>
            <div className="container-fluid">
                <div className="card card-default mt-3">
                    <div className="card-header">
                        <h3 className="card-title"><b>{parentOfTab.title}</b></h3>
                        <div className={"card-tools row"}>
                            {/* {parentOfTab.id !== DVTJCUVAcquireCddParentTabIds.EMAIL_TAB &&
                                <HeaderSearchButtons
                                    parentTabId={parentTab.id}
                                    tabId={currentTab.id}
                                    showBtnSearchPipeline
                                    showBtnSearchCdd
                                />
                            } */}
                            <HeaderSearchButtons
                                showBtnSearchPipeline={showBtnSearchPipeline}
                                showBtnSearchCdd
                                parentTabId={parentOfTab?.id}
                            />
                            {parentOfTab.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB &&
                                <Button variant='info' onClick={() => onSelectTemplate()} className={"ml-3 btn-sm"}>
                                    Chọn template
                                </Button>
                            }
                            {(parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB
                                // || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB
                                || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.HOT_JOB_NOT_HAS_PLAN_TAB
                                || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_REP_TAB
                                || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.PENDING_PROCESS_TAB
                                || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.SERVICE_EXPIRE_TAB
                            ) &&
                                <Button variant='info' onClick={onEmailFU}
                                    disabled={selectPipelines.length === 0}
                                    className={"ml-3 btn-sm"}>
                                    Email FU
                                </Button>
                            }

                            {(parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_CALL_CHAT_TAB
                                    || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB
                                    || parentOfTab.id === DVTJCUVAcquireCddParentTabIds.HOT_JOB_NOT_HAS_PLAN_TAB
                                ) &&
                                <div className={'col-sm-3 ml-3'}>
                                    <select className='mr-0'
                                            style={{
                                                padding: '0.25rem',
                                                border: '1px solid #ced4da',
                                                borderRadius: '0.25rem',
                                                boxShadow: 'inset 0 0 0 transparent',
                                                transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
                                            }}
                                            name={'sortBy'}
                                            value={sortBy}
                                            onChange={event => onChangeSortOption(event)}>
                                        <option value={PipeLineSortOption.NOTE_TIME_ASC}>Note time xa hiện tại hơn lên
                                            trước
                                        </option>
                                        <option value={PipeLineSortOption.NOTE_TIME_DESC}>Note time gần hiện tại hơn lên
                                            trước
                                        </option>
                                        {parentTab.id === DVTJCUVAcquireCddParentTabIds.UV_NEED_ME_FU_TAB && (
                                            <>
                                                <option value={PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_ASC}>Thời gian
                                                    quá hạn nhiều hơn lên trước
                                                </option>
                                                <option value={PipeLineSortOption.FU_SCHEDULE_NEXT_TIME_DESC}>Thời gian
                                                    quá hạn ít hơn lên trước
                                                </option>
                                            </>
                                        )}
                                    </select>
                                </div>
                            }
                        </div>

                    </div>

                    <div className="card-body p-0">
                        {isShowCandidateList() ?
                            (
                                <>
                                    <ul className='nav nav-tabs' role='tablist'>
                                        {childTabList.map(itab => (
                                            <li className='nav-item' key={`saved-list-tab-item-${itab.id}`}>
                                                <a className={`nav-link ${activeTab(itab)}`} data-toggle='tab'
                                                   href={`#${itab.id}`}
                                                   onClick={() => onTabClicked(itab)}>{itab.title} ({mailTabData[itab.id] ? mailTabData[itab.id] : 0})
                                                </a>

                                            </li>
                                        ))}
                                    </ul>
                                    <div className='tab-content'>
                                        {childTabList.map((itab, index) => {
                                            if (currentTab.id === itab.id) {
                                                return setShowCandidateListTabContent(itab)
                                            }
                                            return "";
                                        })}
                                    </div>
                                </>
                            ) : (
                                setShowPipelineListTabContent()
                            )
                        }
                    </div>
                </div>
            </div>

            {showSelectMailTemplateModal &&
                <SelectDVTJCUVMailTemplateModal
                    onConfirm={(templateId) => onConfirmSelectTemplate(templateId)}
                    onClose={() => setShowSelectTemplateModal(false)}
                    isShow={showSelectMailTemplateModal}/>
            }
            {showUpdatePipelineModal &&
                <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                                            pipeLineInfo={selectPipeline}
                                            onClose={(reload) => setShowUpdatePipelineModal(false)}
                />
            }

            {showDVTJCUVEmailInviteModal &&
                <DVTJCUVEmailInviteModal candidateIds={[...new Set(selectPipelines.map(item => item.cdd_id))]}
                                         onClose={() => setShowDVTJCUVEmailInviteModal(false)}
                                         isShow={showDVTJCUVEmailInviteModal}/>
            }

            {showFollowUpModal &&
                <DVTJCUVEmailInviteModal candidateIds={[...new Set(selectPipelines.map(item => item.cdd_id))]}
                                         pipelines={selectPipelines}
                                         mode={EmailInviteMode.INVITE_EMAIL_FU}
                                         onClose={() => setShowFollowUpModal(false)}
                                         isShow={showFollowUpModal}/>
            }
        </>
    )
}

export default AcquireCddsContent;
